import api from './axios';

export const getChatSessions = () => api.get('/chat/');
export const getChat = (parcelId) => api.get(`/chat/${parcelId}/`);
export const getChatMessages = (parcelId) => api.get(`/chat/${parcelId}/messages/`);
export const initChat = (parcelId, data) => api.post(`/chat/${parcelId}/init/`, data);
export const sendMessage = (parcelId, data) => api.post(`/chat/${parcelId}/send/`, data);

export const uploadParcelImage = (parcelId, formData) =>
  api.post(`/parcels/${parcelId}/upload-image/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
